/**
 * Supported Pixel models. The cloud's `GET /installer/models` is authoritative (it carries
 * `active` per model, at most two active in the field — Part A2); this table is the offline
 * fallback and the source of the purchase-spec text shown before sign-in.
 */
export interface SupportedModel {
  /** Installer model id == codename. */
  id: string;
  name: string;
  codename: string;
  tier: "standard" | "budget" | "successor" | "agent";
  soc: string;
  ram_gb: number;
  google_updates_until: string;
  /** Whether customers may install today. */
  active: boolean;
  /** Google factory-image page for this codename (public). */
  factory_images_url: string;
}

export const FACTORY_IMAGES_PAGE = "https://developers.google.com/android/images";

export const FALLBACK_MODELS: readonly SupportedModel[] = [
  { id: "tegu", name: "Pixel 9a", codename: "tegu", tier: "standard", soc: "Tensor G4", ram_gb: 8, google_updates_until: "2032-04", active: true, factory_images_url: `${FACTORY_IMAGES_PAGE}#tegu` },
  { id: "akita", name: "Pixel 8a", codename: "akita", tier: "budget", soc: "Tensor G3", ram_gb: 8, google_updates_until: "2031-05", active: true, factory_images_url: `${FACTORY_IMAGES_PAGE}#akita` },
];

/** Exact purchase spec — surfaced verbatim (translated) on the sign-in screen. */
export const PURCHASE_SPEC_KEY = "models.purchase_spec";

/**
 * Heuristic markers of US carrier variants seen in bootloader vars (`variant`, `sku`,
 * `carrier`, `product`). These are NOT authoritative — the authoritative gate is
 * `flashing get_unlock_ability` — but they let us explain *why* unlocking is blocked.
 */
export const US_CARRIER_MARKERS: readonly { re: RegExp; carrier: string }[] = [
  { re: /\b(vzw|verizon)\b/i, carrier: "Verizon" },
  { re: /\b(att|at&t|cricket)\b/i, carrier: "AT&T" },
  { re: /\b(tmo|tmobile|t-mobile|metro)\b/i, carrier: "T-Mobile" },
  { re: /\b(sprint)\b/i, carrier: "Sprint" },
  { re: /\b(xfinity|comcast)\b/i, carrier: "Xfinity" },
  { re: /\b(usc|uscc|uscellular)\b/i, carrier: "US Cellular" },
  { re: /\b(spectrum|charter)\b/i, carrier: "Spectrum" },
  { re: /\b(visible|fi)\b/i, carrier: "Google Fi / Visible" },
];
